
import React from 'react';

interface IProps {
  style?: any;
  
}

export const ViewAllIcon:React.FC<IProps> = (props: IProps) => {
  return (
<svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_2111_34205)">
<circle cx="38" cy="38" r="22" fill="white"/>
</g>
<line x1="49" y1="38.5" x2="26" y2="38.5" stroke="#204078" stroke-width="2" strokeLinecap="round"/>
<g filter="url(#filter1_d_2111_34205)">
<path d="M52.0032 38.3992C51.9974 38.1541 51.901 37.9198 51.7324 37.7417L45.7916 31.5533C45.6088 31.3645 45.3585 31.2558 45.0958 31.2511C44.833 31.2465 44.579 31.3462 44.3896 31.5284C44.2002 31.7106 44.0908 31.9605 44.0854 32.2233C44.0799 32.4861 44.1788 32.7403 44.3605 32.9302L49.6438 38.4302L44.3605 43.9301C44.1788 44.1201 44.0799 44.3743 44.0854 44.6371C44.0908 44.8998 44.2002 45.1497 44.3896 45.332C44.579 45.5142 44.833 45.6139 45.0958 45.6092C45.3585 45.6045 45.6088 45.4959 45.7916 45.307L51.7324 39.1186C51.8232 39.0228 51.894 38.9098 51.9405 38.7863C51.9869 38.6627 52.0083 38.5311 52.0032 38.3992V38.3992Z" fill="#204078"/>
</g>
<defs>
<filter id="filter0_d_2111_34205" x="0" y="0" width="84" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="4" dy="4"/>
<feGaussianBlur stdDeviation="10"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2111_34205"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2111_34205" result="shape"/>
</filter>
<filter id="filter1_d_2111_34205" x="16" y="8" width="69" height="69" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="4" dy="4"/>
<feGaussianBlur stdDeviation="10"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2111_34205"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2111_34205" result="shape"/>
</filter>
</defs>
</svg>


    
  )
}
